import actionTypes from "./types";

export const addWallet = (wallet) => ({
    type: actionTypes.ADD_WALLET,
    payload: wallet,
});

export const updateWallet = (payload) => ({
    type: actionTypes.UPDATE_WALLET,
    payload,
});

export const deleteWallet = (uid) => ({
    type: actionTypes.DELETE_WALLET,
    payload: { uid },
});

export const setSelectedWallet = (wallet) => ({
    type: actionTypes.SET_SELECTED_WALLET,
    payload: wallet,
});

export const setWalletBalanceCache = (chain, address, data) => ({
    type: actionTypes.SET_WALLET_BALANCE_CACHE,
    payload: { chain, address, data },
});

export const updateBackedupWallets = (wallets = []) => ({
    type: actionTypes.UPDATE_BACKEDUP_WALLETS,
    payload: wallets,
});
